import React, { useState } from "react";
import logoGvm from "../assets/logo-gvm.png";

// CATEGORIE E PRESTAZIONI CUP
const CATEGORIE_GVM = {
  "Visite specialistiche": [
    "Visita cardiologica",
    "Visita Andrologica",
    "Visita Angiologica",
    "Visita Cardiologica Interventistica",
    "Visita elettrofisiologica cardiologica",
    "Visita urologica",
    "Visita vascolare",
    "Visita Chirurgia vascolare",
    "Visita Cardiochirurgica (controllo)"
  ],
  "Ecografie e cardiologia": [
    "Ecocardiogramma",
    "Ecografia addome completo",
    "Ecografia addome superiore",
    "Ecografia addome inferiore",
    "Ecografia apparato urinario",
    "Ecografia prostata sovrapubica",
    "Ecografia tiroide",
    "Ecografia collo",
    "Ecografia ghiandole salivari",
    "Ecografia mammaria bilaterale",
    "Ecografia mammaria monolaterale",
    "Ecografia spalla",
    "Ecografia ginocchio",
    "Ecografia muscolo-tendinea",
    "Ecografia parti molli",
    "EcoColorDoppler carotideo",
    "EcoColorDoppler arti inferiori"
  ],
  "TC": [
    "TC encefalo senza mezzo di contrasto",
    "TC encefalo con mezzo di contrasto",
    "TAC massiccio facciale",
    "TC seni paranasali",
    "TC torace",
    "TAC torace ad alta risoluzione (HRCT)",
    "Angio-TC torace",
    "TC collo",
    "TC addome",
    "TC addome e pelvi",
    "Uro-TC",
    "TC rachide cervicale",
    "TC rachide dorsale",
    "TC rachide lombosacrale",
    "TC spalla",
    "TC anca",
    "TC ginocchio",
    "Angio-TC coronarica",
    "TAC bacino",
    "Angio-TC encefalo",
    "Angio-TC carotidi",
    "Angio-TC aorta addominale",
    "Angio TC Arto inferiore",
    "Angio TC Arto inferiore Destro",
    "TAC total body"
  ],
  "Risonanza Magnetica": [
    "Risonanza magnetica encefalo senza mezzo di contrasto",
    "Risonanza magnetica encefalo con mezzo di contrasto",
    "Risonanza magnetica encefalo con e senza mezzo di contrasto",
    "Risonanza magnetica ipofisi",
    "Risonanza magnetica rachide cervicale",
    "Risonanza magnetica rachide dorsale",
    "Risonanza magnetica rachide lombosacrale",
    "Risonanza magnetica colonna vertebrale completa",
    "Risonanza magnetica spalla",
    "Risonanza magnetica anca",
    "Risonanza magnetica ginocchio",
    "Risonanza magnetica bacino",
    "Risonanza magnetica prostata multiparametrica",
    "Risonanza magnetica addome completo",
    "Colangio-RM",
    "Angio-RM encefalo",
    "Angio-RM carotidi",
    "Risonanza magnetica total body"
  ],
  "Altro": ["Altro (specificare nelle note)"]
};

export default function CupGvm() {
  const [categoria, setCategoria] = useState("");
  const [sending, setSending] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const [dati, setDati] = useState({
    nome: "",
    telefono: "",
    email: "",
    prestazione: "",
    note: ""
  });

  const handleChange = (e) => {
    setDati({ ...dati, [e.target.name]: e.target.value });
  };

  const testoRichiesta = () => `
Richiesta CUP – Maria Eleonora Hospital (GVM)

Nome e Cognome: ${dati.nome}
Telefono: ${dati.telefono}
Email: ${dati.email || "Non fornita"}

Prestazione richiesta:
${dati.prestazione}

Note:
${dati.note || "Nessuna"}

Richiesta inviata tramite app Medicajato Center
(Punto CUP decentrato)
`;

  const inviaEmail = () => {
    if (sending) return;
    setSending(true);

    const subject = encodeURIComponent(
      "Richiesta prenotazione – CUP Maria Eleonora Hospital"
    );
    const body = encodeURIComponent(testoRichiesta());

    window.location.href = `mailto:info@medicajato.it?subject=${subject}&body=${body}`;

    setTimeout(() => setSending(false), 1500);
  };

  const inviaWhatsApp = () => {
    if (sending) return;
    setSending(true);

    const msg = encodeURIComponent(testoRichiesta());
    window.open(`https://wa.me/393383395427?text=${msg}`, "_blank");

    setTimeout(() => setSending(false), 1500);
  };

  const invioConsentito =
    dati.nome &&
    dati.telefono &&
    dati.prestazione &&
    !sending;

  return (
    <div
      style={{
        padding: "40px 20px",
        maxWidth: "700px",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif"
      }}
    >
      {/* LOGO */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img src={logoGvm} alt="GVM" style={{ width: "180px" }} />
        <p style={{ fontSize: "14px", color: "#555" }}>
          CUP Maria Eleonora Hospital
        </p>
      </div>
        <p style={{
  fontSize: "14px",
  color: "#555",
  textAlign: "center",
  marginBottom: "25px",
  lineHeight: "1.5"
}}>
  Questa sezione consente di inviare una <strong>richiesta di prenotazione </strong>per prestazioni sanitarie erogate dal <strong>Maria Eleonora Hospital</strong>.<br />
  Il <strong>Medicajato Center</strong> opera come <strong>punto CUP decentrato</strong>.<br />
  Data e orario verranno concordati successivamente.
</p>


      {/* DATI PAZIENTE */}
      <input
        type="text"
        name="nome"
        placeholder="Nome e Cognome"
        value={dati.nome}
        onChange={handleChange}
        style={{ width: "100%", padding: "10px", marginBottom: "12px" }}
      />

      <input
        type="tel"
        name="telefono"
        placeholder="Telefono"
        value={dati.telefono}
        onChange={handleChange}
        style={{ width: "100%", padding: "10px", marginBottom: "12px" }}
      />

      <input
        type="email"
        name="email"
        placeholder="Email (facoltativa)"
        value={dati.email}
        onChange={handleChange}
        style={{ width: "100%", padding: "10px", marginBottom: "12px" }}
      />

      {/* CATEGORIE */}
      <h3>Seleziona categoria</h3>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
          gap: "12px",
          marginBottom: "20px"
        }}
      >
        {Object.keys(CATEGORIE_GVM).map((cat) => (
          <button
            key={cat}
            type="button"
            onClick={() => {
              setCategoria(cat);
              setDati({
                ...dati,
                prestazione: CATEGORIE_GVM[cat][0]
              });
            }}
            style={{
              padding: "14px",
              borderRadius: "18px",
              border: "none",
              backgroundColor: categoria === cat ? "#8b0000" : "#eee",
              color: categoria === cat ? "white" : "#333",
              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* PRESTAZIONI */}
      {categoria && (
        <select
          name="prestazione"
          value={dati.prestazione}
          onChange={handleChange}
          style={{ width: "100%", padding: "10px", marginBottom: "12px" }}
        >
          {CATEGORIE_GVM[categoria].map((p, i) => (
            <option key={i} value={p}>
              {p}
            </option>
          ))}
        </select>
      )}

      <textarea
        name="note"
        placeholder="Note aggiuntive (opzionali)"
        value={dati.note}
        onChange={handleChange}
        rows={3}
        style={{ width: "100%", padding: "10px" }}
      />

      {/* INVIO */}
      <button
        disabled={!invioConsentito}
        onClick={() => setShowPreview(true)}
        style={{
          marginTop: "20px",
          width: "100%",
          padding: "14px",
          backgroundColor: invioConsentito ? "#8b0000" : "#ccc",
          color: "white",
          border: "none",
          borderRadius: "30px",
          fontSize: "16px",
          cursor: invioConsentito ? "pointer" : "not-allowed"
        }}
      >
        {sending ? "Invio in corso..." : "Invia richiesta CUP"}
      </button>

      {/* ANTEPRIMA */}
      {showPreview && (
        <div
          style={{
            marginTop: "25px",
            border: "1px solid #ccc",
            borderRadius: "12px",
            padding: "15px"
          }}
        >
          <h3>Conferma richiesta</h3>
          <pre style={{ whiteSpace: "pre-wrap" }}>{testoRichiesta()}</pre>

          <button
            disabled={sending}
            onClick={inviaEmail}
            style={{ width: "100%", padding: "10px", marginTop: "10px" }}
          >
            📧 Invia via Email
          </button>

          <button
            disabled={sending}
            onClick={inviaWhatsApp}
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "10px",
              backgroundColor: "#25D366",
              color: "white",
              border: "none",
              borderRadius: "8px"
            }}
          >
            💬 Invia via WhatsApp
          </button>

          <button
            onClick={() => setShowPreview(false)}
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "10px",
              backgroundColor: "#eee",
              border: "none"
            }}
          >
            Annulla
          </button>
        </div>
      )}

      <p style={{ marginTop: "25px", fontSize: "13px", color: "#666" }}>
        ℹ️ Le prestazioni saranno erogate esclusivamente dal
        <strong> Maria Eleonora Hospital</strong>.  
        Il Medicajato Center opera come punto CUP decentrato.
      </p>
    </div>
  );
}
